import type { Hotel_HotelInfoSettingsPageQuery } from "@/lib/gql/__generated__/graphql";
import { type LangCode } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";
import { FeatureIslandContainer, FeatureIslandHeader } from "@/components/features/_layouts";

import { HotelSettingsHotelInfoAdditionalIsland } from "./island/additional";
import { HotelSettingsHotelInfoBaseSettingsIsland } from "./island/base";
import { HotelSettingsHotelInfoDetailedInfoSettingsIsland } from "./island/detailed-info";
import { UpdateButton } from "./update-button";
import { useInitialized } from "../../model/usecase/use-init";

type Props = {
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
	data: Hotel_HotelInfoSettingsPageQuery;
};

export const HotelSettingsHotelInfoDefaultPresenter = ({ activeLangCode, navigator, data }: Props) => {
	const {
		viewModel,
		logoMethods,
		keyVisualMethods,
		hotelSettingsHotelInfoFormModelMethods,
		addressMethods,
		geoLocationMethods,
		snsMethods,
		onUpdateHotelSettingsHotelInfoDefault,
	} = useInitialized({
		data,
	});

	const isDirty = viewModel.isDirty;
	useTransitionBlock(isDirty);

	return (
		<FeatureIslandContainer>
			<FeatureIslandHeader
				title="施設情報の編集"
				activeLangCode={activeLangCode}
				navigator={navigator}
				rightChildren={
					<UpdateButton
						isDirty={isDirty}
						hasError={viewModel.hasError}
						onClickCallback={onUpdateHotelSettingsHotelInfoDefault}
					/>
				}
			/>

			<HotelSettingsHotelInfoBaseSettingsIsland
				viewModel={viewModel}
				logoMethods={logoMethods}
				keyVisualMethods={keyVisualMethods}
				hotelSettingsHotelInfoFormModelMethods={hotelSettingsHotelInfoFormModelMethods}
			/>

			<HotelSettingsHotelInfoDetailedInfoSettingsIsland
				viewModel={viewModel}
				addressMethods={addressMethods}
				geoLocationMethods={geoLocationMethods}
				hotelSettingsHotelInfoFormModelMethods={hotelSettingsHotelInfoFormModelMethods}
			/>

			<HotelSettingsHotelInfoAdditionalIsland
				viewModel={viewModel}
				snsMethods={snsMethods}
				hotelSettingsHotelInfoFormModelMethods={hotelSettingsHotelInfoFormModelMethods}
			/>
		</FeatureIslandContainer>
	);
};

HotelSettingsHotelInfoDefaultPresenter.displayName = "HotelSettingsHotelInfoDefaultPresenter";
